// Author yujiabei
// Date 2021-07-14 17:07:59

import * as model from "@/model/em/admin/EmAdmFactoryModelEafmModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmAdmFactoryModelEafm(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'emAdmFactoryModelEafm',
        modelFilter: model.filter
    })
    .buildStore()
